import { Schema } from '@togglecorp/ravl';

const commonSchema: Schema[] = [
    {
        extends: 'dbentity',
        doc: {
            name: 'project',
            description: 'Project schema',
        },
        fields: {
            title: { type: 'string', required: true },
            description: { type: 'string' },
            charging: { type: 'number' },
            members: { type: 'array.number', required: true },
        },
    },
    {
        doc: {
            name: 'projects',
            description: 'Response for projects list',
        },
        fields: {
            count: { type: 'uint', required: true },
            next: { type: 'string' },
            previous: { type: 'string' },
            results: { type: 'array.project', required: true },
        },
    },
    {
        doc: {
            name: 'projectMini',
            description: 'Project mini information',
        },
        fields: {
            id: { type: 'uint', required: true },
            title: { type: 'string', required: true },
        },
    },
];


export default commonSchema;
